import { render, staticRenderFns } from "./StIconCarouselElement.vue?vue&type=template&id=745ffd3c"
import script from "./StIconCarouselElement.vue?vue&type=script&lang=ts"
export * from "./StIconCarouselElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports